module.exports = __webpack_public_path__ + "img/gfx-step-3_x3.5ac3a212.webp";